export type HoSoTenFields = {
  firstName?: string | null
  lastName?: string | null
} | null | undefined

const escapeRegExp = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

/** `needle` đã xuất hiện như một cụm từ trong `haystack` (biên khoảng trắng / `-`). */
const containsAsWord = (haystack: string, needle: string): boolean => {
  if (!needle) return false
  if (haystack === needle) return true
  const re = new RegExp(`(^|[\\s-])${escapeRegExp(needle)}(?=$|[\\s-])`)
  return re.test(haystack)
}

/**
 * Gộp họ tên từ hồ sơ user.
 *
 * Dữ liệu banhang thường: `firstName` = «NV###-Họ Đệm Tên», `lastName` = «Tên».
 * Nối thẳng sẽ ra «… Mai Mai» — nếu first đã chứa last thì chỉ lấy first.
 * Trường hợp chuẩn (Họ / Tên tách): trả về «Họ + Tên» (lastName + firstName).
 */
export const hoTenFromHoSo = (hoSo: HoSoTenFields): string => {
  const first = String(hoSo?.firstName ?? '').trim()
  const last = String(hoSo?.lastName ?? '').trim()
  if (!first) return last
  if (!last) return first
  if (containsAsWord(first, last)) return first
  if (containsAsWord(last, first)) return last
  return `${last} ${first}`.trim()
}
